/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';

/**
 * 
 * @export
 * @interface PreorderSummaryResponseDto
 */
export interface PreorderSummaryResponseDto {
    /**
     * Название размещения
     * @type {string}
     * @memberof PreorderSummaryResponseDto
     */
    accommodationName: string;
    /**
     * Тип размещения
     * @type {string}
     * @memberof PreorderSummaryResponseDto
     */
    accommodationType: string;
    /**
     * Название комнаты/номера
     * @type {string}
     * @memberof PreorderSummaryResponseDto
     */
    roomName: string;
    /**
     * Property images
     * @type {Array<TravelineResourceDto>}
     * @memberof PreorderSummaryResponseDto
     */
    images: Array<TravelineResourceDto>;
}

/**
 * Check if a given object implements the PreorderSummaryResponseDto interface.
 */
export function instanceOfPreorderSummaryResponseDto(value: object): value is PreorderSummaryResponseDto {
    if (!('accommodationName' in value) || value['accommodationName'] === undefined) return false;
    if (!('accommodationType' in value) || value['accommodationType'] === undefined) return false;
    if (!('roomName' in value) || value['roomName'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    return true;
}

export function PreorderSummaryResponseDtoFromJSON(json: any): PreorderSummaryResponseDto {
    return PreorderSummaryResponseDtoFromJSONTyped(json, false);
}

export function PreorderSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreorderSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'accommodationName': json['accommodationName'],
        'accommodationType': json['accommodationType'],
        'roomName': json['roomName'],
        'images': ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
    };
}

  export function PreorderSummaryResponseDtoToJSON(json: any): PreorderSummaryResponseDto {
      return PreorderSummaryResponseDtoToJSONTyped(json, false);
  }

  export function PreorderSummaryResponseDtoToJSONTyped(value?: PreorderSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accommodationName': value['accommodationName'],
        'accommodationType': value['accommodationType'],
        'roomName': value['roomName'],
        'images': ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
    };
}

